module.exports = __webpack_public_path__ + "img/AE.ca85264c.jpg";